import React, {useState, useEffect} from 'react';
import '../../pages/PerfilAgencia/PerfilAgenciaNuevo.css';
import {useNavigate, createSearchParams} from 'react-router-dom';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import logo_sharecare1 from '../../assets/logo_sharecare1.png';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import {animateScroll as scroll} from 'react-scroll';
import {makeStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {ModalesPerfilAgencia} from './ModalesPerfilAgencia';
import {ServicioOfrecido} from './ServicioOfrecido';
import { PaqueteOfrecido } from './PaqueteOfrecido';
import Carousel from 'react-multi-carousel';
import { ReactImageCarouselViewer } from "react-image-carousel-viewer";
import 'react-multi-carousel/lib/styles.css';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {Valoracion} from '../marketPlace/Valoracion';
import {Reseñas} from './Reseñas';
import { useLocation } from 'react-router-dom';
import {
	EmailShareButton,
	FacebookShareButton,
	InstapaperShareButton,
	LineShareButton,
	LinkedinShareButton,
	TelegramShareButton,
	TwitterShareButton,
	WhatsappShareButton,
	EmailIcon,
	FacebookIcon,
	LineIcon,
	LinkedinIcon,
	TelegramIcon,
	TwitterIcon,
	WhatsappIcon,
} from 'react-share';

// Step 2: Invoke and pass your desired calendar as a function in the render prop
export const ContentBodyPerfilAgencia = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;

	const [MyDate, setMyDate] = useState(new Date());

	const {id} = useParams();

	/* A hook that is used to store the user's data in the session. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const [ModalAnadirServicio, setModalAnadirServicio] = useState(false);
	const [ModalAnadirServicioShareCare, setModalAnadirServicioShareCare] = useState(false);

	const [ModalUsuarioNoRegistrado, setModalUsuarioNoRegistrado] = useState(false);

	const [ModalPacientes, setModalPacientes] = useState(false);

	/* A hook that is used to navigate between pages. */
	const navigate = useNavigate();

    const [Empresa, setEmpresa] = useState({ datos: {}, img: "", servicios: [], sede: {}, paquetes: [] });

    const [ServicioId, setServicioId] = useState();

    const [ModalAnadirPaqueteServicioShareCare, setModalAnadirPaqueteServicioShareCare] = useState(false);

	const [DiasNoCompletos, setDiasNoCompletos] = useState([]);

	const [DiasLibres, setDiasLibres] = useState([]);

	const [Periodos, setPeriodos] = useState([]);

	const [Periodo, setPeriodo] = useState([]);

	const [Paciente, setPaciente] = useState({});

	const [ListaHoras, setListaHoras] = useState([]);

	const [ListaHorasShareCare, setListaHorasShareCare] = useState([]);

	const [ListaPacientes, setListaPacientes] = useState([]);

	const [GaleriaEmpresa, setGaleriaEmpresa] = useState([]);

	const [ServiciosContratados, setServiciosContratados] = useState([]);

    const [Servicio, setServicio] = useState({
        "id": 0,
        "servicio_id": {
            "id": 0,
            "nombre": "",
            "categoria_id": {
                "id": 0,
                "nombre": ""
            },
            "tipo": ""
        },
        "horasMin": 0,
        "precioMin": 0,
        "estado": "",
        "descripcion": ""
    })

    const [Paquete, setPaquete] = useState({
        "id": 0,
        "precio": 0,
        "nombrePaquete": "",
        "prestadorServicios": "",
        "descripcion": ""
    })

    
    const [ paymentIntent, setPaymentIntent ] = useState("");
    const [ clientSecret, setClientSecret ] = useState("");
    const [ stripeMessage, setStripeMessage ] = useState("");
    const [ factura, setFactura ] = useState("");

	const [imagesUrls, setImagesUrls] = useState([])

	const {state} = useLocation();

	const [q, setQ] = useState(0);
	const [lugar, setLugar] = useState(0);

	useEffect(()=>{
		setQ(state?.q ? state?.q : 0);
		setLugar(state?.lugar ? state?.lugar : 0)
	},[state])

    useEffect(()=>{
        console.log('imagesUrls', imagesUrls)
    },[imagesUrls])
    const [isOpen, setIsOpen] = useState(false);
    const [index, setIndex] = useState(0);

	const getServicio = () => {
		if (ServicioId !== undefined) {
			axios({
				method: 'get',
				url: window.ipdirection + 'servicioEmpresaCliente/' + ServicioId + '/',
			})
				.then((response) => {
					setServicio({...response.data});
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};

	/**
	 * Esta función nos da las horas en las que ese dia hay un servicio de otro paciente que tiene el mismo código postal
	 */
	const getHorasShareCare = () => {
		axios({
			method: 'get',
			url:
				window.ipdirection +
				'horasShareCare/?servicio_empresa_id=' +
				Servicio.id +
				'&dia=' +
				MyDate.toISOString().slice(0, 10) +
				'&codPostal=' +
				Paciente.codigoPostalPaciente,
		})
			.then((response) => {
				setListaHorasShareCare(response.data.HorasCogidas);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		getServicio();
	}, [ServicioId]);

	const comparadorNombre = (a, b) => {
		if (a.nombre < b.nombre) {
			return -1;
		}
		if (a.nombre > b.nombre) {
			return 1;
		}
		return 0;
	};
	const ordenarLista = (lista) => {
		return lista.sort(comparadorNombre);
	};
	const getGaleriaEmpresa = () => {
		setGaleriaEmpresa([]);
		axios({
			method: 'get',
			url: window.ipdirection + 'galeriaEmpresaCliente/?prestador=' + id,
		})
			.then((response) => {
				let lista = GaleriaEmpresa;
				response.data.forEach((element) => {
					axios({
						method: 'get',
						url: window.ipdirection + 'galeriaEmpresaCliente/' + element.id + '/',
						responseType: 'blob',
					})
						.then((response) => {
							lista.push({
								url: URL.createObjectURL(response.data),
								nombre: element.nombre,
								id: element.id,
							});
							imagesUrls.push({
								src: URL.createObjectURL(response.data),
								description: element.nombre,
								id: element.id,

							})
							setGaleriaEmpresa([...ordenarLista(lista)]);
						})
						.catch((error) => {
							console.log(error);
						});
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getDatosEmpresa = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'prestadorServiciosCliente/' + id + '/',
		})
			.then((response) => {
				axios({
					method: 'get',
					url: window.ipdirection + 'localidadAll/' + response.data.localidad.id + '/',
				})
					.then((response2) => {
						axios({
							method: 'get',
							url:
								window.ipdirection +
								'provinciaAll/' +
								response2.data.provincia.id +
								'/',
						})
							.then((response3) => {
								let datos = {
									...response.data,
									localidadNombre: response2.data.nombre,
									provinciaNombre: response3.data.nombre,
								};
								setEmpresa((prevState) => ({...prevState, datos: datos}));
							})
							.catch((error) => console.log(error));
					})
					.catch((error) => console.log(error));
			})
			.catch((error) => console.log(error));

		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilEmpresaCliente/' + id + '/',
			responseType: 'blob',
		})
			.then((response) => {
				setEmpresa((prevState) => ({
					...prevState,
					img: URL.createObjectURL(response.data),
				}));
			})
			.catch((error) => console.log(error));

		axios({
			method: 'get',
			// url: window.ipdirection + "sedePrestador_Cliente/" + id + "/"
			url: window.ipdirection + 'sedePrestador/?idempresa=' + id,
		})
			.then((response) => {
				console.log('Sede_Prestador_CLiente ', response.data);
				setEmpresa((prevState) => ({...prevState, sede: response.data}));
			})
			.catch((error) => console.log(error));

        axios({
            method: "get",
            url: window.ipdirection + "servicioEmpresaCliente/?empresa_id=" + id
        }).then(response => {
            let lista = [];
            response.data.map(servicio => {
                console.log(servicio)
                lista.push({ ...servicio });
            });
            setEmpresa(prevState => ({ ...prevState, servicios: lista }));
        }).catch(error => console.log(error));

        axios({
            method: "get",
            url: window.ipdirection + "paqueteServicios/?idPrestador=" + id
        }).then(response => {
            let lista = [];
            response.data.map(paquete => {
                lista.push({ ...paquete });
                console.log(paquete)
            });
            setEmpresa(prevState => ({ ...prevState, paquetes: lista }));
        }).catch(error => console.log(error));


		getGaleriaEmpresa();
	};

	/**
	 * Esto se llama una vez se ha renderizado el componente
	 *
	 * Si en la lista tiene un useState se llama al useEffect
	 */
	useEffect(() => {
		scroll.scrollToTop();
		getDatosEmpresa();
		getPacientes();
	}, []);

	/**
	 *Esta funcion es llamada cuando se le a la boton de (carrito de compra)añadir para traer la informacion de las horas libres que tiene ese servcio y los dias
	 *
	 * @param {*} Servicio_id
	 */
	const generarListaDias = (Servicio_id) => {
		const fechaActual = new Date();
		let url =
			window.ipdirection +
			'diasLibres/?prestador_id=' +
			id +
			'&servicio_empresa_id=' +
			Servicio_id +
			'&mes=4&year=2023';
		axios({
			method: 'get',
			url: url,
		})
			.then((response) => {
				let dias_no_completos = [];
				// iterar sobre los objetos dentro de dias_no_completos
				response.data.dias_no_completos.forEach((objeto) => {
					// obtener la clave (fecha) del objeto
					let fecha = Object.keys(objeto)[0];
					// obtener los horarios del objeto
					let horarios = objeto[fecha];
					// agregar a la lista dias_no_completos
					dias_no_completos.push({fecha: fecha, horarios: horarios});
				});
				setDiasNoCompletos([...dias_no_completos]);
			})
			.catch((error) => console.log(error));
	};

	const getPeriodos = (Servicio_id) => {
		axios({
			url: window.ipdirection + 'periodoServicioCliente/?servicio_empresa=' + Servicio_id,
			method: 'get',
		}).then((response) => {
			setPeriodos([...response.data]);
		});
	};

	const getHoras = () => {
		getHorasShareCare();
	};

	useEffect(() => {
		// pasamos la fecha a formato YYYY-MM-DD para poder buscar si es una fecha con horario completo y tiene huecos ocupados
		const fechaISO = MyDate.toISOString(); // "2023-04-24T08:16:28.000Z"
		const fechaCorta = fechaISO.slice(0, 10); // "2023-04-24"
		// Buscamos si se encuentra en los dias que tienen un hueco
		let encontrado = false;
		if (DiasNoCompletos !== undefined) {
			DiasNoCompletos.map((dia) => {
				// si se encuentra se selecciona el periodo que le corresponde
				if (dia.fecha === fechaCorta) {
					setPeriodo([...dia.horarios]);
					generarHorasDisponibles([...dia.horarios]);
					encontrado = true;
				}
			});
		}
		// Si no ha sido encontraod se fabrica un periodo libre completo
		if (!encontrado) {
			makePeriodoCompleto();
		}
	}, [ListaHorasShareCare]);

	const makePeriodoCompleto = (fechaCorta) => {
		// Crear array de nombres de días de la semana
		var diasSemana = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

		// Obtener número del día de la semana
		var numDiaSemana = MyDate.getDay();

		// Obtener nombre del día de la semana correspondiente al número
		let nombreDiaSemana = diasSemana[numDiaSemana];
		nombreDiaSemana = nombreDiaSemana.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
		// buscamos la duracion del servcio
		let duracion = Servicio.horasMin;

		// buscamos los periodos que correspondan a esa hora de la semana
		let listaPeriodos = [];

		Periodos.forEach((dia) => {
			if (dia.nombre == nombreDiaSemana) {
				listaPeriodos.push({hora_inicio: dia.hora_inicio, hora_fin: dia.hora_fin});
			}
		});
		setPeriodo([...obtenerIntervalosValidos(listaPeriodos, duracion)]);
		generarHorasDisponibles([...obtenerIntervalosValidos(listaPeriodos, duracion)]);
	};

	/**
	 * Esta función recibe un arreglo de horarios y una duración en minutos,
	 * y devuelve un arreglo con los intervalos de tiempo disponibles
	 * dentro de cada horario que tienen una duración igual o mayor
	 * a la duración especificada.
	 *
	 * @param {Array} horarios - Arreglo de objetos con los horarios disponibles
	 * @param {Number} duracionMinutos - Duración mínima requerida en minutos
	 * @returns {Array} - Arreglo con los intervalos de tiempo disponibles
	 */
	const obtenerIntervalosValidos = (horarios, duracionMinutos) => {
		const intervalosValidos = [];
		for (let i = 0; i < horarios.length; i++) {
			const horario = horarios[i];
			const fechaInicio = new Date(`01/01/2000 ${horario.hora_inicio}`);
			const fechaFin = new Date(`01/01/2000 ${horario.hora_fin}`);
			let intervaloInicio = new Date(
				fechaInicio.setMinutes(fechaInicio.getMinutes() + duracionMinutos)
			);
			while (
				new Date(fechaInicio.setMinutes(fechaInicio.getMinutes() + duracionMinutos)) <
				fechaFin
			) {
				const intervaloFin = new Date(intervaloInicio.getTime() + duracionMinutos * 60000);
				intervalosValidos.push(intervaloInicio.toLocaleTimeString());
				intervaloInicio = intervaloFin;
			}
		}
		return intervalosValidos;
	};

	const comprobarShareCareFecha = (horaAcomprobar) => {
		let ShareCare = false;
		if (ListaHorasShareCare.length > 0) {
			const finWhile = ListaHorasShareCare.length;
			let iterator = 0;
			while (iterator < finWhile && !ShareCare) {
				ShareCare = tieneShareCare(horaAcomprobar, ListaHorasShareCare[iterator]);
				iterator++;
			}
		}
		return ShareCare;
	};
	const formatearHora = (hora) => {
		const partesHora = hora.split(':');
		const horaFormateada = partesHora
			.map((parte) => {
				return parte.length === 1 ? '0' + parte : parte;
			})
			.join(':');
		return horaFormateada;
	};

	const tieneShareCare = (horaAcomprobar, horaListaShareCare) => {
		// Convertir las fechas a objetos Date de JavaScript
		let fecha1Obj = new Date(`01/01/2000 ${horaAcomprobar}`);
		let fecha2Obj = new Date(`01/01/2000 ${horaListaShareCare}`);

		// Calcular la cantidad de minutos de cada fecha
		let fecha1Min = fecha1Obj.getHours() * 60 + fecha1Obj.getMinutes();
		let fecha2Min = fecha2Obj.getHours() * 60 + fecha2Obj.getMinutes();

		// Sumar o restar minutos a la primera fecha
		let nuevaFecha1Min = fecha1Min + 50;
		let nuevaFecha1Min2 = fecha1Min - 50;

		// Convertir la nueva fecha a un objeto Date de JavaScript
		let nuevaFecha1Obj = new Date(`01/01/2000 00:${nuevaFecha1Min}`);
		let nuevaFecha1Obj2 = new Date(`01/01/2000 00:${nuevaFecha1Min2}`);

		// Formatear la nueva fecha en formato "HH:MM:SS"
		let nuevaFecha1 = nuevaFecha1Obj.toLocaleTimeString('es-ES');
		let nuevaFecha2 = nuevaFecha1Obj2.toLocaleTimeString('es-ES');

		// Verificar si la nueva fecha es igual a la segunda fecha
		if (
			formatearHora(nuevaFecha1) === horaListaShareCare ||
			formatearHora(nuevaFecha2) === horaListaShareCare
		) {
			return true;
		} else {
			return false;
		}
	};

	function convertirHora(hora) {
		const [horaString, minutosString, segundosString] = hora.split(':');
		return `${horaString.padStart(2, '0')}:${minutosString}`;
	}

	const generarHorasDisponibles = (Per) => {
		const horasDisponibles = Per.map((hora) => ({
			hora: convertirHora(hora),
			estado: false,
			shareCare: comprobarShareCareFecha(convertirHora(hora)),
		}));

		setListaHoras(horasDisponibles);
	};

	const getPacientes = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'pacienteByCliente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				getInfoPaciente(response.data.results);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const getInfoPaciente = (lista) => {
		let listaPacientes = [];

		lista.map((paciente) => {
			axios({
				method: 'get',
				url: window.ipdirection + 'imagenPerfilPaciente/?paciente_id=' + paciente.id,
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			})
				.then((response) => {
					axios({
						method: 'get',
						url:
							window.ipdirection +
							'imagenPerfilPaciente/' +
							response.data[0].id +
							'/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						responseType: 'blob',
					})
						.then((response2) => {
							paciente = {
								...paciente,
								fotoPaciente: URL.createObjectURL(response2.data),
							};
							axios({
								method: 'get',
								url:
									window.ipdirection + 'localidadAll/' + paciente.localidad + '/',
							})
								.then((response3) => {
									axios({
										method: 'get',
										url:
											'https://geocode.maps.co/search?q=' +
											response3.data.nombre +
											',Spain',
									})
										.then((response4) => {
											paciente = {
												...paciente,
												lat: response4.data[0].lat,
												lon: response4.data[0].lon,
											};
											listaPacientes.push({...paciente, estado: true});
											setListaPacientes([...listaPacientes]);
										})
										.catch((error) => {
											listaPacientes.push({...paciente, estado: true});
											setListaPacientes([...listaPacientes]);
											console.log(error);
										});
								})
								.catch((error) => {
									listaPacientes.push({...paciente, estado: true});
									setListaPacientes([...listaPacientes]);
									console.log(error);
								});
						})
						.catch((error) => {
							listaPacientes.push({...paciente, estado: true});
							setListaPacientes([...listaPacientes]);
							console.log(error);
						});
				})
				.catch((error) => {
					listaPacientes.push({...paciente, estado: true});
					setListaPacientes([...listaPacientes]);
					console.log(error);
				});
		});
	};

	const comprobaciones = () => {
		if (Usuario.tipo === 'noRegistrado') {
			setModalUsuarioNoRegistrado(true);
			return false;
		} else {
			if (ListaPacientes.length === 0) {
				setModalPacientes(true);
				return false;
			} else {
				return true;
			}
		}
		return false;
	};

	const seleccionarPaciente = (id) => {
		const listaActualizada = ListaPacientes.map((paciente) =>
			paciente.id === id
				? {...paciente, seleccionado: true}
				: {...paciente, seleccionado: false}
		);
		setPaciente(listaActualizada.find((paciente) => paciente.id === id));
	};

	const getHora = () => {
		let horaSel;
		ListaHoras.forEach((hora) => {
			if (hora.estado == true) {
				horaSel = hora;
			}
		});
		return horaSel;
	};
	const modFecha = (date) => {
		const year = date.getFullYear();
		const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Sumar 1 al mes ya que empieza en 0
		const day = date.getDate().toString().padStart(2, '0');

		return `${year}-${month}-${day}`;
	};
	const enviarServicio = async () => {
		let hora = getHora();
		let valided = false;
		if (MyDate && hora && Paciente && Object.keys(Paciente).length !== 0) {
			let data = {
				fechaServicio: modFecha(MyDate),
				estado: 0,
				paciente_id: Paciente.id,
				servicio_Empresa_id: Servicio.id,
				hora_inicio: hora.hora + ':00',
				shareCare: hora.shareCare,
				empresa_id: Empresa.datos['id'],
			};
			try {
				await axios({
					url: window.ipdirection + 'servicioEmpresaPacienteCliente/',
					headers: {
						Authorization: 'Bearer ' + Usuario.access,
					},
					method: 'post',
					data: data,
				}).then((response) => {
					let res = response.data['reserva'];
					guardarFactura(res);
				});
				setMyDate(new Date());
				setPaciente({});
				valided = true;
			} catch (error) {
				console.log(error.response.data);
			}
		}
		return valided;
	};
	const responsive = {
		desktop: {
			breakpoint: {max: 3000, min: 1024},
			items: 3,
			slidesToSlide: 3, // optional, default to 1.
		},
		tablet: {
			breakpoint: {max: 1024, min: 464},
			items: 2,
			slidesToSlide: 2, // optional, default to 1.
		},
		mobile: {
			breakpoint: {max: 464, min: 0},
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
			centerMode: true,
		},
	};

	/***************************************** PAGO SRIPE **********************************************/
	const get_clientSecret = async () => {
		let data = {
			amount: Servicio.precioMin * 100,
		};

		await axios({
			method: 'post',
			url: window.ipdirection + 'config-client-secret/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				let cs = response.data['client_secret'];
				setClientSecret(cs);
				setPaymentIntent(response.data['paymentIntent']);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const createPayment = async (paymentMethod) => {
		let aceptado = false;
		let data = {
			description: Empresa.datos.nombreEmpresa + ' - ' + Servicio.servicio_id.nombre,
			name: Usuario.cliente['nombre'] + ' ' + Usuario.cliente['apellidos'],
			paymentIntent: paymentIntent,
			paymentMethod_id: paymentMethod,
			amount: Servicio.precioMin * 100,
			email: Usuario.cliente.usuario['email'],
			Agencia: id,
		};

		await axios({
			method: 'post',
			url: window.ipdirection + 'stripe-payment/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				setFactura(response.data['invoice']);
				aceptado = true;
			})
			.catch((error) => {
				let message = error.response['data']['error'];
				setStripeMessage(message);
			});

		return aceptado;
	};

	const guardarFactura = async (res) => {
		let data = {
			factura: factura,
			paymentIntent: paymentIntent,
			amount: Servicio.precioMin * 100,
			servicio_empresa_paciente: res,
		};

		await axios({
			method: 'post',
			url: window.ipdirection + 'guardar-factura/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {})
			.catch((error) => {
				console.log(error);
			});
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={20}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>

			<div className='content-body-perfil-agencia-nuevo'>
				<div className='info-perfil-agencia-nuevo'>
					<div className='descripcion-perfil-agencia centrador descripcion-servicio flecha'>
						<div className='centrador menu-header' onClick={()=>{navigate({pathname: '/busqueda',
																				search: '?' + createSearchParams({q: q, lugar:lugar})
																			})}}
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H6M12 5l-7 7 7 7"/></svg>
						</div>
					</div>
					<div className='foto-perfil-agencia centrador'>
						<img src={Empresa.img} />
					</div>
					<div className='nombre-perfil-agencia '>
						<div className='nombre-perfil-agencia-der'>
							<h2>{Empresa.datos.nombreEmpresa}</h2>
							<Valoracion empresaId={id} />
						</div>
						<div className='nombre-perfil-agencia-izq'>
							<div className='direccion-empresa-perfil-agencia-nuevo'>
								<b>Localidad :</b>
								{Empresa.datos.provinciaNombre +
									' - ' +
									Empresa.datos.localidadNombre}
							</div>
							<div className='direccion-empresa-perfil-agencia-nuevo'>
								<b>Dirección :</b>
								{Empresa.datos.direccion}
							</div>
							{/* <div className='direccion-empresa-perfil-agencia-nuevo'>
								<b>Teléfono :</b>
								{Empresa.datos.telefono}
							</div> */}
						</div>
					</div>
					<div className='descripcion-perfil-agencia centrador descripcion-servicio'>
						{Empresa.datos.descripcionEmpresa}
					</div>
					{/* <div className='icons-share-perfil-agencia'>
						<div></div>
						<WhatsappShareButton url={window.ipdirection + 'perfilAgencia/' + id}>
							<WhatsappIcon size={40} />
						</WhatsappShareButton>
						<TelegramShareButton url={window.ipdirection + 'perfilAgencia/' + id}>
							<TelegramIcon size={40} />
						</TelegramShareButton>
						<TwitterShareButton url={window.ipdirection + 'perfilAgencia/' + id}>
							<TwitterIcon size={40} />
						</TwitterShareButton>
						<FacebookShareButton url={window.ipdirection + 'perfilAgencia/' + id}>
							<FacebookIcon size={40} />{' '}
						</FacebookShareButton>
						<LinkedinShareButton url={window.ipdirection + 'perfilAgencia/' + id}>
							<LinkedinIcon size={40} />
						</LinkedinShareButton>
					</div> */}
				</div>

				<div className='seleccion-servicios-perfil-agencia-nuevo'>
					<h3>Servicios Disponibles</h3>
					{Empresa.servicios && Empresa.servicios.length > 0 ?
						Empresa.servicios.map((servicio, index) => {
							return (
								<ServicioOfrecido
									servicio={servicio}
									setServicioId={setServicioId}
									setModalAnadirServicio={setModalAnadirServicio}
									setModalAnadirServicioShareCare={setModalAnadirServicioShareCare}
									generarListaDias={generarListaDias}
									getPeriodos={getPeriodos}
									comprobaciones={comprobaciones}
								/>
							);
					}):
					<p>{Empresa.datos.nombreEmpresa} aún no dispone de servicios.</p>}
                    <h3>Paquetes de Servicios Disponibles</h3>
                    {Empresa.paquetes && Empresa.paquetes.length > 0 ?
                        Empresa.paquetes.map((paquete, index) => {
                            return (
                                <PaqueteOfrecido
                                    paquete={paquete}
                                    setPaquete={setPaquete}
                                    setModalAnadirServicio={setModalAnadirServicio}
                                    setModalAnadirPaqueteServicioShareCare={setModalAnadirPaqueteServicioShareCare}
                                    //generarListaDias={generarListaDias}
                                    //getPeriodos={getPeriodos}
                                    comprobaciones={comprobaciones}
                                />
                            )
                        }):
						<p>{Empresa.datos.nombreEmpresa} aún no ofrece paquetes de servicios.</p>}
				</div>
				<div className='carrousel-imagenes-perfil-empresa'>
					<Carousel
						swipeable={false}
						draggable={true}
						centerMode={false}
						focusOnSelect={true}
						autoPlay={true}
						autoPlaySpeed={3000}
						transitionDuration={800}
						responsive={responsive}
						ssr={true} // means to render carousel on server-side.
						infinite={true}
						keyBoardControl={true}
						containerClass='carousel-container'
						deviceType={responsive.desktop}
						removeArrowOnDeviceType={['tablet', 'mobile']}
						dotListClass='custom-dot-list-style'
						itemClass='carousel-item-padding-40-px'
					>
						{GaleriaEmpresa.map((foto, key) => (
							<div className='imagen-carrousel-perfil-agencia'>
								<img src={foto.url}
									onClick={() => {
										setIndex(key);
										setIsOpen(true);
									}}  />
							</div>
						))}
					</Carousel>
					<ReactImageCarouselViewer
						open={isOpen}
						onClose={() => setIsOpen(false)}
						images={imagesUrls}
						startIndex={index}
						disableScroll={true}
						containerClass='carousel-viewer-container'
					/>
				</div>
				<Reseñas empresaId={id} Empresa={Empresa}/>
			</div>
			<ModalesPerfilAgencia
				ModalAnadirServicio={ModalAnadirServicio}
				setModalAnadirServicio={setModalAnadirServicio}
				ModalAnadirServicioShareCare={ModalAnadirServicioShareCare}
				setModalAnadirServicioShareCare={setModalAnadirServicioShareCare}
                ModalAnadirPaqueteServicioShareCare={ModalAnadirPaqueteServicioShareCare}
                setModalAnadirPaqueteServicioShareCare={setModalAnadirPaqueteServicioShareCare}
				ServicioId={ServicioId}
				Servicio={Servicio}
                Paquete={Paquete}
				MyDate={MyDate}
				setMyDate={setMyDate}
				ServiciosContratados={ServiciosContratados}
				setServiciosContratados={setServiciosContratados}
				idPrestador={id}
				DiasNoCompletos={DiasNoCompletos}
				DiasLibres={DiasLibres}
				Periodos={Periodos}
				Periodo={Periodo}
				getHoras={getHoras}
				generarHorasDisponibles={generarHorasDisponibles}
				ListaHoras={ListaHoras}
				setListaHoras={setListaHoras}
				ModalUsuarioNoRegistrado={ModalUsuarioNoRegistrado}
				setModalUsuarioNoRegistrado={setModalUsuarioNoRegistrado}
				ModalPacientes={ModalPacientes}
				setModalPacientes={setModalPacientes}
				ListaPacientes={ListaPacientes}
				Paciente={Paciente}
				seleccionarPaciente={seleccionarPaciente}
				enviarServicio={enviarServicio}
				empresa={Empresa}
				getHorasShareCare={getHorasShareCare}
				createPayment={createPayment}
				get_clientSecret={get_clientSecret}
				clientSecret={clientSecret}
				stripeMessage={stripeMessage}
				factura={factura}
			/>
		</>
	);
};
